import { TableHead, TableHeader, TableRow } from "@/components/ui/table/table";

export const SearchResultTableTHead = () => (
	<TableHeader className="relative bg-bg-layer-400">
		<TableRow className="hover:bg-transparent">
			<TableHead justifyStyle="center" className="font-semibold">
				レシートID
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				名前
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				購入日
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				合計料金
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				電話番号
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				メールアドレス
			</TableHead>

			<TableHead justifyStyle="center" className="font-semibold">
				購入商品
			</TableHead>
		</TableRow>
	</TableHeader>
);
